import { type UseQueryOptions, useQuery } from "@tanstack/react-query";

import {
	getProductCatalogPartners,
	type PartnerResponse,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import keys from "../keys";

export const usePartnersQuery = (
	categoryCode: string | null | undefined,
	options?: Omit<UseQueryOptions<PartnerResponse[]>, "queryKey" | "queryFn">,
) => {
	return useQuery({
		queryKey: keys.partners(categoryCode),
		queryFn: processResponse(() => getProductCatalogPartners(categoryCode)),
		...options,
	});
};
